// src/emaillog/index.js — екран „Изпратени" (Фаза 3.2). Пренесен дословно от app.js.

import { el, clear } from '../shared/dom.js';
import { dateInput } from '../shared/dates.js';
import { dfmt } from '../shared/format.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { emptyState } from '../shared/ui.js';
import { xlsxDownload } from '../shared/xlsx.js';
import { state, cq } from '../shared/state.js';
import { openModal, closeModal } from '../shared/modal.js';

export async function view(page) {
  clear(page);
  if (!state().activeCompany) return window.CRM.needsCompany(page);
  let logs = [];
  try { logs = await api('/emaillog' + cq()); } catch (e) { toast(e.message, true); }
  const fromI = dateInput('');
  const toI = dateInput('');
  function fmtDT(s) { if (!s) return '—'; const d = new Date(s); return dfmt(s) + ' ' + (isNaN(d) ? '' : d.toTimeString().slice(0, 5)); }
  function filtered() {
    return logs.filter((r) => {
      const d = (r.created_at || '').slice(0, 10);
      if (fromI.dataset.iso && d < fromI.dataset.iso) return false;
      if (toI.dataset.iso && d > toI.dataset.iso) return false;
      return true;
    }).sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
  }
  // Прегледът показва ТОЧНИЯ текст на пратеното писмо (Макс, 15.09.2026) —
  // стандартния или дописания на ръка. Стар запис отпреди журналът да пази
  // текста не мълчи, а го казва.
  function previewMail(r) {
    const b = String(r.body || '');
    const bodyText = b.trim() ? b : '(няма запазен текст)';
    openModal({
      title: 'Писмо до клиента',
      body: el('div', {},
        el('div', { style: 'margin-bottom:6px' }, el('b', { text: 'Тема: ' }), el('span', { text: r.subject || '—' })),
        el('div', { style: 'margin-bottom:6px' }, el('b', { text: 'До: ' }), el('span', { text: r.to || '—' })),
        el('div', { style: 'margin-bottom:10px' }, el('b', { text: 'Дата/час: ' }), el('span', { text: fmtDT(r.created_at) })),
        el('div', { style: 'margin-bottom:4px' }, el('b', { text: 'Съобщение:' })),
        // pre-wrap: новите редове остават, дългият ред се пренася.
        r.has_link ? el('div', { style: 'margin-bottom:6px;color:var(--muted);font-size:13px', text: 'Под текста писмото има личен линк „Изтеглете фактурата“ (документът не е прикачен) — отвори ли го клиентът, тук пише кога.' }) : null,
        el('pre', { style: 'white-space:pre-wrap;font-family:inherit;font-size:13.5px;background:var(--surface-2);border:1px solid var(--border);border-radius:8px;padding:10px 12px;margin:0;max-height:50vh;overflow:auto', text: bodyText })),
      foot: el('div', {}, el('button', { class: 'btn ghost', text: 'Затвори', onClick: closeModal })),
    });
  }
  // Линкът „Вижте фактурата" (т. 3m): кога клиентът я е отворил. Старите
  // писма (без линк) и неуспешните — тире.
  function openedText(r) {
    if (r.opened_at) return fmtDT(r.opened_at) + (Number(r.open_count) > 1 ? ' (' + r.open_count + ' пъти)' : '');
    return (r.has_link && r.status === 'sent') ? 'Още не' : '—';
  }
  function openedCell(r) {
    return r.opened_at ? el('span', { class: 'tag teal', text: openedText(r) }) : el('span', { style: 'color:var(--muted)', text: openedText(r) });
  }
  const tbodyWrap = el('div');
  function draw() {
    clear(tbodyWrap);
    const rows = filtered();
    if (!rows.length) { tbodyWrap.appendChild(emptyState('✉', 'Още няма изпратени имейли за тази фирма.')); return; }
    const tb = el('tbody');
    rows.forEach((r) => {
      const dt = fmtDT(r.created_at);
      tb.appendChild(el('tr', {},
        el('td', { class: 'hide-sm', style: 'width:140px' }, dt),
        el('td', {}, (r.doc_kind === 'proforma' ? 'Проформа № ' : '№ ') + (r.invoice_number || r.invoice_id || '')),
        el('td', {}, r.to || ''),
        el('td', { class: 'hide-sm' }, r.sent_by_name || ''),
        el('td', {}, el('span', { class: 'tag ' + (r.status === 'sent' ? 'green' : 'red'), text: r.status === 'sent' ? 'Изпратен' : 'Грешка' })),
        el('td', {}, openedCell(r)),
        el('td', { style: 'width:90px' }, el('button', { class: 'btn sm ghost', text: 'Преглед', 'aria-label': 'Преглед на писмото до ' + (r.to || '') + ' от ' + dt, onClick: () => previewMail(r) }))
      ));
    });
    tbodyWrap.appendChild(el('table', {}, el('thead', {}, el('tr', {},
      el('th', { class: 'hide-sm', text: 'Дата/час' }), el('th', { text: 'Фактура' }), el('th', { text: 'До' }), el('th', { class: 'hide-sm', text: 'От' }), el('th', { text: 'Статус' }), el('th', { text: 'Отворено' }), el('th', { text: 'Писмо' })
    )), tb));
  }
  fromI.addEventListener('change', draw);
  toI.addEventListener('change', draw);
  const head = el('div', { class: 'panel-head' },
    el('h2', { text: 'Изпратени фактури (имейл)' }),
    el('div', { style: 'display:flex;gap:6px;align-items:center;flex-wrap:wrap' },
      el('span', { style: 'font-size:13px;color:var(--muted)', text: 'от' }), fromI,
      el('span', { style: 'font-size:13px;color:var(--muted)', text: 'до' }), toI),
    el('button', { class: 'btn sm ghost', text: 'Експорт', onClick: () => {
      const rows = filtered();
      if (!rows.length) { toast('Няма редове за експорт.', true); return; }
      const data = rows.map((r) => ({
        'Дата/час': fmtDT(r.created_at),
        'Фактура': r.invoice_number || r.invoice_id || '',
        'До': r.to || '',
        'От': r.sent_by_name || '',
        'Статус': r.status === 'sent' ? 'Изпратен' : 'Грешка',
        'Отворено от клиента': openedText(r),
        'Грешка': r.error || '',
        'Съобщение': r.body || '',
      }));
      xlsxDownload(data, 'Izprateni', 'izprateni-fakturi.xlsx');
    } })
  );
  const panel = el('div', { class: 'panel' });
  panel.appendChild(head);
  panel.appendChild(tbodyWrap);
  page.appendChild(panel);
  draw();
}

